import { faClose, IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface ModalHeaderProps {
	title: string;
	onClose: () => void;
	icon?: IconDefinition;
}

export const ModalHeader = ({ title, icon = faClose, onClose }: ModalHeaderProps) => {
	return (
		<div className="flex text-start justify-between">
			<h2 className="text-lg font-medium  text-gray-900">{title}</h2>

			<div className="flex size-6 shrink-0 items-center justify-center self-start px-1 py-0.5" onClick={onClose}>
				<FontAwesomeIcon icon={icon} className="cursor-pointer text-xl font-normal" />
			</div>
		</div>
	);
};
